module.exports = __webpack_public_path__ + "img/ottavoLavoro.0bfeb52d.jpg";